import { Translate } from "@omni/types/utils/translate";
import { addMethod, date, string as yupString } from "yup";

import { substract } from "@/utils/date";

import { string } from "./general.RHF";

const parseInteger = (value: string) => {
    const trimmedValue = String(value).trim();

    return trimmedValue === "" ? 0 : parseInt(trimmedValue, 10);
};

addMethod(yupString, "validYear", function () {
    return this.test("validYear", function (value) {
        if (!value) {
            return true;
        }

        const length = value.toString().length;

        if (length !== 4) {
            return this.createError({
                message: () => () => (t: Translate) =>
                    t("general.form.input.validation.dateOfBirth.invalidDate")
            });
        }

        const val = parseInteger(value);

        if (val >= new Date().getFullYear()) {
            return this.createError({
                message: () => () => (t: Translate) =>
                    t(
                        "form.validation.input.number.max.value",
                        t(
                            "general.form.customer.dateOfBirth.year.label"
                        ).toLowerCase(),
                        new Date().getFullYear()
                    )
            });
        } else if (val <= 1900) {
            return this.createError({
                message: () => () => (t: Translate) =>
                    t(
                        "form.validation.input.number.min.value",
                        t(
                            "general.form.customer.dateOfBirth.year.label"
                        ).toLowerCase(),
                        1900
                    )
            });
        }

        return true;
    });
});

addMethod(yupString, "validDay", function () {
    return this.test("validDay", function (value) {
        if (!value) {
            return true;
        }

        const val = parseInteger(value);
        if (val < 1) {
            return this.createError({
                message: () => () => (t: Translate) =>
                    t(
                        "form.validation.input.number.min.value",
                        t(
                            "general.form.customer.dateOfBirth.day.label"
                        ).toLowerCase(),
                        1
                    )
            });
        }

        return (
            val <= 31 ||
            this.createError({
                message: () => () => (t: Translate) =>
                    t(
                        "form.validation.input.number.max.value",
                        t(
                            "general.form.customer.dateOfBirth.day.label"
                        ).toLowerCase(),
                        31
                    )
            })
        );
    });
});

addMethod(yupString, "validMonth", function () {
    return this.test("validMonth", function (value) {
        if (!value) {
            return true;
        }

        const val = parseInteger(value);
        if (val < 1) {
            return this.createError({
                message: () => () => (t: Translate) =>
                    t(
                        "form.validation.input.number.min.value",
                        t(
                            "general.form.customer.dateOfBirth.month.label"
                        ).toLowerCase(),
                        1
                    )
            });
        }

        return (
            val <= 12 ||
            this.createError({
                message: () => () => (t: Translate) =>
                    t(
                        "form.validation.input.number.max.value",
                        t(
                            "general.form.customer.dateOfBirth.month.label"
                        ).toLowerCase(),
                        12
                    )
            })
        );
    });
});

export const optionalDateOfBirthDay = string().nullable().optional().validDay();

export const optionalDateOfBirthMonth = string()
    .nullable()
    .optional()
    .validMonth();

export const optionalDateOfBirthYear = string()
    .nullable()
    .optional()
    .validYear();

export const optionalDateOfBirth = date()
    .nullable()
    .optional()
    .max(substract(new Date(), { days: 1 }));

export const dateOfBirthDay = string().nullable().required().validDay();

export const dateOfBirthMonth = string().nullable().required().validMonth();

export const dateOfBirthYear = string().nullable().required().validYear();

export const dateOfBirth = date()
    .nullable()
    .required()
    .max(substract(new Date(), { days: 1 }));
